export const profile = {
  pathname: '/profile'
}

export const updateProfilePreferences = {
  pathname: '/preferences',
  method: 'PUT',
  headers: {
    'content-type': 'application/json',
    accept: 'application/json'
  },
  body: ({ preferences }) => {
    return {
      user: {
        preferences
      }
    }
  },
  onResponse: async res => {
    const data = await res.text()
    if (!res.ok) {
      const e = new Error(`PUT /preferences - ${res.status}`)
      e.data = data.error
      e.status = res.status
      throw e
    }
    return data
  }
}
